export default __webpack_public_path__ + "static/media/docgif.6d03cf67.gif";